// Warmup daily-games hub route — see components/games/WarmupScreen.
import { WarmupScreen } from '../../components/games/WarmupScreen/WarmupScreen';

export default function GamesScreen() {
  return <WarmupScreen />;
}
